export default {
  namespaced: true,
  state: {
    // 栏目菜单
    menuListTwo:[
      // 校园安全管理
      {
        menuName:'安全资料',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/1.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/1.svg',
        path:'/update_school_data',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"本校基本信息",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/3.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/3.svg',
          path:'/update_school_data',jumpMode:0,showStatus:1,list:[]},
          {name:"人员基本资料",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/2.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/2.svg',
          path:'',showStatus:1,list:[
            {name:'学校师生信息',path:'/teacher_data',jumpMode:0,showStatus:1,sublevelList:[
              {name:"教师信息",path:'/teacher_data',},
              {name:"学生信息",path:'/student_data',},
              {name:"家长信息",path:'/parents_data',},
            ]},
            {name:'校内职务架构',path:'/department_management',jumpMode:0,showStatus:1,sublevelList:[
              {name:"组织架构",path:'/department_management',},
              {name:"职务管理",path:'/job_management',},
              {name:"隐患小组",path:'/security_group',},
              {name:"报修小组",path:'/repairs_group',},
              {name:"班级管理",path:'/class_management',},
              {name:"宿舍管理",path:'/apartmentBuilding',}
            ]},
            {name:'平台权限管理',path:'/authority_settings',jumpMode:0,showStatus:1,sublevelList:[
              {name:"权限设置",path:'/authority_settings',},
              {name:"推送设置",path:'/message_authority',}
            ]}
          ]},
          {name:"安全档案填报",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/3.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/3.svg',
          path:'',list:[
            {name:'安保档案填报',path:'/security_archives',jumpMode:0,showStatus:1},
            {name:'消防档案填报',path:'/fire_archives',jumpMode:0,showStatus:1},
            {name:'校车档案填报',path:'/schoolbus_archives',jumpMode:0,showStatus:1},
            {name:'器械档案填报',path:'/apparatus_archives',jumpMode:0,showStatus:1}
          ]},
          {name:"学生健康管理",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/4.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/4.svg',
          showStatus:1,list:[
            {name:'特异学生档案',path:'/special_students_archives',jumpMode:0,showStatus:1},
            {name:'心理健康档案',path:'/mental_health_archives',jumpMode:0,showStatus:1},
            {name:'突发事件管理',path:'/emergency_management',jumpMode:0,showStatus:1},
            {name:'留守儿童档案',path:'/home_children_archives',jumpMode:0,showStatus:1},
            {name:'定期家访管理',path:'/home_visit_management',jumpMode:0,showStatus:1}
          ]}
        ]
      },
      {
        menuName:'安全管理',
        
        
        
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/5.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/5.svg',path:'/not_done_matter',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"待办事项",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/6.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/6.svg',
          path:'/not_done_matter',jumpMode:0,showStatus:1,list:[]},
          {name:"专项检查",path:'/special_inspect',jumpMode:0,showStatus:1,
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/7.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/7.svg',
          list:[]},
          {name:"通知公告",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/8.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/8.svg',
          path:'/improving_notice',jumpMode:0,showStatus:1,list:[]},
          {name:"任务下发",path:'/task_issue',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/22.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/22.svg',
          showStatus:1,list:[
            // {name:'上级任务',path:'/task_issue',jumpMode:0,showStatus:1},
            // {name:'工作任务',path:'/superior_task_distribution',jumpMode:0,showStatus:1},
            // {name:'安全教育计划',path:'/safety_education_program',jumpMode:0,showStatus:1},
            // {name:'安全活动',path:'/safety_activities',jumpMode:0,showStatus:1},
            // {name:'安全制度管理',path:'/superior_system',jumpMode:0,showStatus:1}
          ]},
          {name:"安全会议",path:'/school_meetings',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/8.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/8.svg',
          
          list:[
            // {name:'学校会议',path:'/school_meetings',jumpMode:0,showStatus:1},
            // {name:'教育局会议',path:'/education_bureau_meeting',jumpMode:0,showStatus:1}
          ]},
          {name:"问卷调查",path:'/questionnaire',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/33.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/33.svg',
          
          jumpMode:0,showStatus:1,list:[]},
          {name:"食品安全",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/9.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/9.svg',
          path:'',showStatus:1,list:[
            {name:'食堂档案',path:'/canteen_data_new',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食堂信息",path:'/canteen_data_new'},
              {name:"供应商",path:'/school_supplier'},
            ]},
            {name:'食堂制度',path:'/food_system',jumpMode:0,showStatus:1},
            {name:'每周菜单',path:'/weekly_menu',jumpMode:0,showStatus:1},
            {name:'食品追溯',path:'/food_materials',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食品食材",path:'/food_materials'},
              {name:"留样管理",path:'/sample_management'},
              {name:"抽样检测",path:'/sampling_test'},
            ]},
            {name:'陪餐管理',path:'/meal_accompanying_task',jumpMode:0,showStatus:1,sublevelList:[
              {name:"陪餐任务",path:'/meal_accompanying_task'},
              {name:"陪餐记录",path:'/meal_accompanying_record'}
            ]},
            {name:'明厨亮灶',path:'/canteen_camera',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食堂摄像头",path:'/canteen_camera'},
              // {name:"人脸布控",path:'/face_control'}
            ]},
          ]},
          // {name:"家长联防",path:'/homework_management',jumpMode:0,showStatus:1,icon:'el-icon-c-scale-to-original',list:[]},
          {name:"一键报警",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/10.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/10.svg',
          path:'/one_button_alarm',jumpMode:0,showStatus:1,list:[]}
        ]
      },
      {
        menuName:'安全台账',path:'/daily_patrol_statistics',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/30.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/30.svg',

        jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"安全数据统计",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/11.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/11.svg',
          
          showStatus:1,list:[
            {name:'日常巡查统计',path:'/daily_patrol_statistics',jumpMode:0,showStatus:1},
            {name:'安全隐患统计',path:'/hidden_danger_statistics',jumpMode:0,showStatus:1},
            {name:'专项检查统计',path:'/special_inspection_statistics',jumpMode:0,showStatus:1},
            {name:'校际通知统计',path:'/notification_statistics',jumpMode:0,showStatus:1},
          ]},
          {name:"安全评分",path:'/safety_score',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/12.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/12.svg',
          
          list:[]},
          {name:"学校安全报告",path:'/school_safety_report',
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/13.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/13.svg',
          jumpMode:0,showStatus:1,list:[]},
          // {name:"校园安全大数据",path:'/safeposture_school',jumpMode:0,showStatus:1,icon:'el-icon-s-order',list:[]},
        ],
      },
      {
        menuName:'安全教育',path:'/safety_education_video',jumpMode:0,showStatus:1,menuCate:2,
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/38.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc/38.svg',
        subMenuList:[
          // {name:"公共资源库",path:'',icon:'el-icon-s-unfold',showStatus:1,list:[
            // {name:'安全知识库',path:'/public_safety_knowledge',jumpMode:0,showStatus:1},
            // {name:'安全课堂',path:'/public_safety_course',jumpMode:0,showStatus:1},
          // ]},
          // {name:"精品资源库",path:'',icon:'el-icon-s-management',showStatus:1,list:[
            // {name:'精品安全知识',path:'/excellen_safety_knowledge',jumpMode:0,showStatus:1},
            // {name:'精品安全课堂',path:'/excellen_safety_course',jumpMode:0,showStatus:1},
          // ]},
          {name:"上级教育资源",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/39.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc/39.svg',
          showStatus:1,list:[
            {name:'安全教育视频',path:'/safety_education_video',jumpMode:0,showStatus:1},
            {name:'理论知识培训',path:'/knowledge_train_video',jumpMode:0,showStatus:1},
            // {name:'安全知识',path:'/local_safety_knowledge',jumpMode:0,showStatus:1},
            // {name:'安全课堂',path:'/local_safety_course',jumpMode:0,showStatus:1},
            // {name:'资源分类',path:'/resource_classification',jumpMode:0,showStatus:1},
            // {name:'新增本地安全知识',path:'/add_safety_knowledge',jumpMode:0,showStatus:0,superiorMenu:'/resource_classification'},
          ]},
          {name:"双重知识库",path:'/training_check_video',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/40.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/40.svg',
          list:[]},
          {name:"培训考核",path:'',
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/41.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/41.svg',
          showStatus:1,list:[
            {name:'题库',path:'/QuestionBank',jumpMode:0,showStatus:1},
            {name:'测评记录',path:'/testRecord',jumpMode:0,showStatus:1}
          ]},
        ]
      },
      {
        menuName:'安全物联',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/11.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/11.svg',
        
        path:'/safety_inspection',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"教程管理",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/12.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/12.svg',
          showStatus:1,list:[
            {name:'生成编号',path:'/generation_number',jumpMode:0,showStatus:1},
          ]},
          {name:"校园安全监控",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/13.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc/13.svg',
          path:'',showStatus:1,list:[
            {name:'安全巡视',path:'/safety_inspection',jumpMode:0,showStatus:1},
            {name:'视频警告管理',path:'/video_warning_management',jumpMode:0,showStatus:1},
            {name:'视频报警记录',path:'/video_alarm_record',jumpMode:0,showStatus:1},
            {name:'人脸智能分析',path:'/monitor_face_manage',jumpMode:0,showStatus:1},
          ]},
          {name:"校园应急广播",
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/14.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/14.svg',
          path:'',showStatus:1,list:[
            {name:'广播设置',path:'/broadcast_binding',jumpMode:0,showStatus:1,sublevelList:[
              {name:"广播绑定",path:'/broadcast_binding'},
              {name:"广播分组",path:'/broadcast_group'},
            ]},
            {name:'广播资源管理',path:'/broadcast_resources',jumpMode:0,showStatus:1,sublevelList:[
              {name:"广播资源",path:'/broadcast_resources'},
              {name:"系统广播",path:'/system_broadcast'},
              {name:"广播记录",path:'/broadcast_play_record'},
            ]},
            // {name:'作息广播管理',path:'/today_broadcast',jumpMode:0,showStatus:1,sublevelList:[
            //   {name:"今日广播",path:'/today_broadcast'},
            //   {name:"作息广播",path:'/rest_broadcast'},
            //   {name:"作息表设置",path:'/rest_broadcast_settings'},
            //   {name:"作息表任务",path:'/rest_broadcast_settings_task'}
            // ]},
          ]},
          // {name:"校园用电安全",path:'',icon:'el-icon-folder-opened',list:[
            // {name:'设备管理',path:'/electricity_device_management',jumpMode:0,showStatus:1},
            // {name:'用电检测',path:'/electricity_detection',jumpMode:0,showStatus:1},
            // {name:'报警管理',path:'/electricity_alarm_management',jumpMode:0,showStatus:1},
          // ]},
          {name:"校园智慧消防",path:'',
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/15.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/15.svg',
          showStatus:1,list:[
            {name:'海康',path:'/protect_device_management',jumpMode:0,showStatus:1},
            {name:'千里眼',path:'/protect_thousand_management',jumpMode:0,showStatus:1},
            {name:'报警管理',path:'/protect_alarm_management',jumpMode:0,showStatus:1},
        ]},
          // {name:"ISC设备管理",path:'/isc_device_management',jumpMode:0,showStatus:1,icon:'el-icon-coordinate',list:[]},
          // {name:"校园门禁管理",path:'/access_control_management',jumpMode:0,showStatus:1,icon:'el-icon-receiving',list:[]},
          // {name:"报警主机管理",path:'',icon:'el-icon-tickets',list:[
            // {name:'设备管理',path:'/host_device_management',jumpMode:0,showStatus:1},
            // {name:'报警管理',path:'/host_alarm_management',jumpMode:0,showStatus:1},
          // ]},
          {name:"空气检查管理",
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/18.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/18.svg',
          path:'/air_quality_inspection',jumpMode:0,showStatus:1,list:[]},
          // {name:"体温监测",path:'',icon:'el-icon-sunny',showStatus:1,list:[
            // {name:'体温报告',path:'/temperature_statements',jumpMode:0,showStatus:1},
            // {name:'异常统计',path:'/abnormal_statistics',jumpMode:0,showStatus:1},
          // ]},
          {name:"环境检测管理",path:'',
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/19.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/19.svg',
          showStatus:1,list:[
            {name:'环测设备管理',path:'/e_equipment_list',jumpMode:0,showStatus:1},
            {name:'环测设备报警',path:'/a_alarm_list',jumpMode:0,showStatus:1}
          ]},
          {name:"校车管理",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/20.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/20.svg',
          showStatus:1,list:[
            {name:'校车路线管理',path:'/the_bus_route_manage',jumpMode:0,showStatus:1},
            {name:'校车司机管理',path:'/school_bus_driver_manage',jumpMode:0,showStatus:1},
            {name:'跟车人员管理',path:'/car_following_manage',jumpMode:0,showStatus:1}
          ]}
        ],
      },
      {
        menuName:'出入管控',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/21.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/21.svg',
        
        
        path:'/attendance_rule',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"考勤管理",path:'',
          
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/22.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/22.svg',
          showStatus:1,list:[
            {name:'考勤规则',path:'/attendance_rule',jumpMode:0,showStatus:1},
            {name:'考勤记录',path:'/attendance_record',jumpMode:0,showStatus:1},
          ]},
          {name:"访客管理",path:'',
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/21.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/21.svg',
          showStatus:1,list:[
            // {name:'访客机管理',path:'/visitor_machine',jumpMode:0,showStatus:1},
            {name:'访客记录',path:'/visitor_record',jumpMode:0,showStatus:1},
            {name:'访客人员',path:'/interviewed_person',jumpMode:0,showStatus:1},
          ]},
          // {name:"教职工车辆管理",path:'',icon:'el-icon-truck',showStatus:1,list:[
            // {name:'停车场绑定',path:'/car_park_binding',jumpMode:0,showStatus:1},
            // {name:'车辆信息',path:'/car_info',jumpMode:0,showStatus:1},
            // {name:'车辆通行记录',path:'/vehicle_access_records',jumpMode:0,showStatus:1},
          // ]},
          {name:"学生请假管理",path:'/student_leave_management',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/24.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/24.svg',
          list:[]},
          // {name:"黑名单管理",path:'/blacklist_management',jumpMode:0,showStatus:1,icon:'el-icon-money',list:[]},
          {name:"人脸设备管理",path:'/face_device_management',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/25.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/25.svg',
          
          list:[]},
          // {name:"二维码考勤点",path:'/qrcode_attendance_place',jumpMode:0,showStatus:1,icon:'el-icon-files',list:[]},
          // {name:"基础设置",path:'/basic_settings',jumpMode:0,showStatus:1,icon:'el-icon-cpu',list:[]},
        ]
      },
      {
        menuName:'护学岗',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/26.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/26.svg',
        path:'/protect',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"护学岗记录",path:'/protect',jumpMode:0,showStatus:1, icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/26.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/26.svg',list:[]},
          // {name:"护导管理",path:'/protect',jumpMode:0,showStatus:1, icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/26.svg',
          // act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/26.svg',list:[]},
          // {name:"护导点管理",path:'/protect',jumpMode:0,showStatus:1, icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/26.svg',
          // act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/26.svg',list:[]},
        ],
      },
      {
        menuName:'疫情防控',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/27.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/27.svg',
        path:'/epidemic_work_guide',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          // {name:"信息填报",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            // {name:'学校任务',path:'/teacher_task',jumpMode:0,showStatus:1},
            // {name:'教育局任务',path:'/education_bureau_task',jumpMode:0,showStatus:1},
            // {name:'任务模版',path:'/task_template',jumpMode:0,showStatus:1},
          // ]},
          // {name:"疫情防控风险点",path:'/risk_control_location',jumpMode:0,showStatus:1,icon:'el-icon-menu',list:[]},
          {name:"校园防控工作指引",path:'/epidemic_work_guide',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/28.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/28.svg',
          
          list:[]},
          {name:"疫情防控知识",path:'/epidemic_prevention_knowledge',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/29.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/29.svg',
          
          list:[]},
          {name:"健康排查表",path:'/health_checklist',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/30.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/30.svg',
          
          
          list:[]},
          // {name:"学生健康管理",path:'',icon:'el-icon-odometer',showStatus:1,list:[
            // {name:'体温检测',path:'/temperature_testing',jumpMode:0,showStatus:1},
            // {name:'晨午检',path:'/mn_testing',jumpMode:0,showStatus:1},
          // ]},
        ],
      },
      {
        menuName:'心理咨询师',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/31.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/31.svg',
        path:'/extraProtect',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"人员简介",path:'/law_course_user',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/30.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/30.svg',
          list:[]},
          {name:"授课记录",path:'/prelection_record',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/33.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/33.svg',
          
          list:[]},
        ],
      },
      {
        menuName:'警校协作',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/32.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/32.svg',
        
        path:'/extraProtect',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"警校协作记录",path:'/extraProtect',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/35.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/35.svg',
          
          list:[]},
          {name:"警校互动",path:'/extraInteract',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/36.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/36.svg',
          list:[]},
        ],
      },
      {
        menuName:'校长专栏',
        icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/37.svg',
        act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/37.svg',
        path:'/principalColumn',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"校长专栏",path:'/principalColumn',jumpMode:0,showStatus:1,
          icon: 'https://school.zzsasoft.com/uploads/icon/xc/xc/37.svg',
          act_icon:'https://school.zzsasoft.com/uploads/icon/xc/xc_act/37.svg',
          list:[]
          },
        ],
      },
      {
        menuName:'云广播',
        icon: require('@/assets/img/menu/cloud.svg'),
        act_icon:require('@/assets/img/menu/cloud.svg'),
        path:'/cloudDevice',showStatus:1,
        subMenuList:[
          {name:"设备列表",path:'/cloudDevice',jumpMode:0,showStatus:1, //
          icon: require('@/assets/img/menu/cloud_1.svg'),
          act_icon:require('@/assets/img/menu/cloud_1_act.svg'),
          list:[]
          },
          // {name:"任务管理",path:'/cloudTaskList',jumpMode:0,showStatus:1,
          // icon: require('@/assets/img/menu/cloud_1.svg'),
          // act_icon:require('@/assets/img/menu/cloud_1_act.svg'),
          // list:[]
          // },
          // {name:"作息设置",path:'/relaxTimeSet',jumpMode:0,showStatus:1,
          // icon: require('@/assets/img/menu/cloud_1.svg'),
          // act_icon:require('@/assets/img/menu/cloud_1_act.svg'),
          // list:[]
          // },
          {name:"设备资源",path:'/cloudResources',jumpMode:0,showStatus:1,
          icon: require('@/assets/img/menu/cloud_2.svg'),
          act_icon:require('@/assets/img/menu/cloud_2_act.svg'),
          list:[]
          },
          {name:"应急指挥",path:'/cloudPlan',jumpMode:0,showStatus:1,
          icon: require('@/assets/img/menu/cloud_3.svg'),
          act_icon:require('@/assets/img/menu/cloud_3_act.svg'),
          list:[]
          },
          // {name:"应急评估",path:'/cloudPlan',jumpMode:0,showStatus:1,
          // icon: require('@/assets/img/menu/cloud_3.svg'),
          // act_icon:require('@/assets/img/menu/cloud_3_act.svg'),
          // list:[]
          // },
          {name:"应急指挥中心",path:'/CloudDrillCenter',jumpMode:1,showStatus:1,
          icon: require('@/assets/img/menu/cloud_3.svg'),
          act_icon:require('@/assets/img/menu/cloud_3_act.svg'),
          list:[]
          },


          
        ],
      },
      // {
      //   menuName:'心理健康',icon:'/img/yqfk.png',path:'/psychology',jumpMode:0,showStatus:1,menuCate:2,
      //   subMenuList:[
      //     {name:"心理健康",path:'/psychology',jumpMode:0,showStatus:1,icon:'el-icon-s-flag',list:[]}
      //   ],
      // },
      // {
      //   menuName:'校园风采',icon:'/img/xyfc.png',path:'/campus_dynamic',jumpMode:0,showStatus:1,menuCate:2,
      //   subMenuList:[
      //     {name:"校园动态",path:'/campus_dynamic',icon:'el-icon-school',jumpMode:0,showStatus:1,list:[]},
      //     {name:"教师风采",path:'/teacher_style',icon:'el-icon-user',jumpMode:0,showStatus:1,list:[]},
      //     {name:"班级风采",path:'/class_style',icon:'el-icon-house',jumpMode:0,showStatus:1,list:[]},
      //   ]
      // },
    ],

    // 高校栏目菜单(学院)
    menuListAccount:[
      // 校园安全管理
      {
        menuName:'安全资料',icon: require('@/assets/img/menu/2/2.png'),path:'/update_school_data',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"本校基本信息",path:'/update_school_data',jumpMode:0,showStatus:1,list:[]},
          {name:"人员基本资料",path:'',icon:'el-icon-tickets',showStatus:1,list:[
            {name:'学校师生信息',path:'/teacher_data',jumpMode:0,showStatus:1,sublevelList:[
              {name:"教师信息",path:'/teacher_data',},
              {name:"学生信息",path:'/student_data',},
            ]},
            {name:'校内职务架构',path:'/department_management',jumpMode:0,showStatus:1,sublevelList:[
              {name:"组织架构",path:'/department_management',},
              {name:"职务管理",path:'/job_management',},
              {name:"隐患小组",path:'/security_group',},
              {name:"报修小组",path:'/repairs_group',},
              {name:"班级管理",path:'/class_management',},
              {name:"宿舍管理",path:'/apartmentBuilding',}
            ]},
            {name:'平台权限管理',path:'/authority_settings',jumpMode:0,showStatus:1,sublevelList:[
              {name:"权限设置",path:'/authority_settings',},
              {name:"推送设置",path:'/message_authority',}
            ]},
            
          ]},
          {name:"安全档案填报",path:'',icon:'el-icon-folder-opened',list:[
            {name:'保安档案填报',path:'/security_archives',jumpMode:0,showStatus:1},
            {name:'消防档案填报',path:'/fire_archives',jumpMode:0,showStatus:1},
            {name:'校车档案填报',path:'/schoolbus_archives',jumpMode:0,showStatus:1},
            {name:'器械档案填报',path:'/apparatus_archives',jumpMode:0,showStatus:1},
          ]},
          {name:"学生健康管理",path:'',icon:'el-icon-document-copy',showStatus:1,list:[
            {name:'特异体质档案',path:'/special_students_archives',jumpMode:0,showStatus:1},
            {name:'心理健康档案',path:'/mental_health_archives',jumpMode:0,showStatus:1},
            {name:'突发事件管理',path:'/emergency_management',jumpMode:0,showStatus:1}
          ]},
        ]
      },
      {
        menuName:'安全管理',icon: require('@/assets/img/menu/2/4.png'),path:'/not_done_matter',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"待办事项",path:'/not_done_matter',jumpMode:0,showStatus:1,icon:'el-icon-coordinate',list:[]},
          {name:"专项检查",path:'/special_inspect',jumpMode:0,showStatus:1,icon:'el-icon-collection-tag',list:[]},
          {name:"通知公告",path:'/improving_notice',jumpMode:0,showStatus:1,icon:'el-icon-bell',list:[]},
          {name:"任务下发",path:'',icon:'el-icon-s-unfold',showStatus:1,list:[
            {name:'上级任务',path:'/task_issue',jumpMode:0,showStatus:1}
          ]},
          {name:"安全会议",path:'',icon:'el-icon-folder-opened',list:[
            {name:'学校会议',path:'/school_meetings',jumpMode:0,showStatus:1},
          ]},
          {name:"问卷调查",path:'/questionnaire',jumpMode:0,showStatus:1,icon:'el-icon-s-order',list:[]},
          {name:"食品安全",path:'',icon:'el-icon-document-copy',showStatus:1,list:[
            {name:'食堂档案',path:'/canteen_data_new',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食堂信息",path:'/canteen_data_new'},
              {name:"供应商",path:'/school_supplier'},
            ]},
            {name:'食堂制度',path:'/food_system',jumpMode:0,showStatus:1},
            {name:'每周菜单',path:'/weekly_menu',jumpMode:0,showStatus:1},
            {name:'食品追溯',path:'/food_materials',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食品食材",path:'/food_materials'},
              {name:"留样管理",path:'/sample_management'},
              {name:"抽样检测",path:'/sampling_test'},
            ]},
            {name:'陪餐管理',path:'/meal_accompanying_task',jumpMode:0,showStatus:1,sublevelList:[
              {name:"陪餐任务",path:'/meal_accompanying_task'},
              {name:"陪餐记录",path:'/meal_accompanying_record'}
            ]},
            {name:'明厨亮灶',path:'/canteen_camera',jumpMode:0,showStatus:1,sublevelList:[
              {name:"食堂摄像头",path:'/canteen_camera'},
              // {name:"人脸布控",path:'/face_control'}
            ]},
          ]},
          {name:"一键报警",path:'/one_button_alarm',jumpMode:0,showStatus:1,icon:'el-icon-s-opportunity',list:[]},
        ],
      },
      {
        menuName:'安全台账',icon: require('@/assets/img/menu/2/7.png'),path:'/daily_patrol_statistics',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"安全数据统计",path:'',icon:'el-icon-s-data',showStatus:1,list:[
            {name:'日常数据统计',path:'/daily_patrol_statistics',jumpMode:0,showStatus:1},
            {name:'专项检查统计',path:'/special_inspection_statistics',jumpMode:0,showStatus:1},
            {name:'安全隐患统计',path:'/hidden_danger_statistics',jumpMode:0,showStatus:1},
            {name:'校际通知统计',path:'/notification_statistics',jumpMode:0,showStatus:1},
          ]},
          {name:"安全评分",path:'/safety_score',jumpMode:0,showStatus:1,icon:'el-icon-star-on',list:[]},
          {name:"学校安全报告",path:'/school_safety_report',jumpMode:0,showStatus:1,icon:'el-icon-s-order',list:[]},
          // {name:"校园安全大数据",path:'/safeposture_school',jumpMode:0,showStatus:1,icon:'el-icon-s-order',list:[]},
        ],
      },
      {
        menuName:'安全教育',icon: require('@/assets/img/menu/2/3.png'),
        
        path:'/safety_education_video',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"上级教育资源",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            {name:'安全教育视频',path:'/safety_education_video',jumpMode:0,showStatus:1},
            {name:'理论知识培训',path:'/knowledge_train_video',jumpMode:0,showStatus:1}
          ]},
          {name:"双重知识库",path:'/training_check_video',jumpMode:0,showStatus:1,icon:'el-icon-bell',list:[]},
          {name:"培训考核",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            {name:'题库',path:'/QuestionBank',jumpMode:0,showStatus:1},
            {name:'测评记录',path:'/testRecord',jumpMode:0,showStatus:1}
          ]},
        ]
      },
      {
        menuName:'安全物联',icon: require('@/assets/img/menu/2/6.png'),path:'/safety_inspection',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"校园安全监控",path:'',icon:'el-icon-video-camera',showStatus:1,list:[
            {name:'安全巡视',path:'/safety_inspection',jumpMode:0,showStatus:1},
            {name:'视频警告管理',path:'/video_warning_management',jumpMode:0,showStatus:1},
            {name:'视频报警记录',path:'/video_alarm_record',jumpMode:0,showStatus:1},
            {name:'人脸智能分析',path:'/monitor_face_manage',jumpMode:0,showStatus:1},
          ]},
          {name:"校园应急广播",path:'',icon:'el-icon-mic',showStatus:1,list:[
            {name:'广播设置',path:'/broadcast_binding',jumpMode:0,showStatus:1,sublevelList:[
              {name:"广播绑定",path:'/broadcast_binding'},
              {name:"广播分组",path:'/broadcast_group'},
            ]},
            {name:'广播资源管理',path:'/broadcast_resources',jumpMode:0,showStatus:1,sublevelList:[
              {name:"广播资源",path:'/broadcast_resources'},
              {name:"系统广播",path:'/system_broadcast'},
              {name:"广播记录",path:'/broadcast_play_record'},
            ]},
          ]},
          {name:"校园智慧消防",path:'',icon:'el-icon-document-copy',showStatus:1,list:[
            {name:'设备管理',path:'/protect_device_management',jumpMode:0,showStatus:1},
          ]},
          {name:"空气检查管理",path:'/air_quality_inspection',jumpMode:0,showStatus:1,icon:'el-icon-c-scale-to-original',list:[]},
          {name:"环境检测管理",path:'',icon:'el-icon-truck',showStatus:1,list:[
            {name:'环测设备管理',path:'/e_equipment_list',jumpMode:0,showStatus:1},
            {name:'环测设备报警',path:'/a_alarm_list',jumpMode:0,showStatus:1}
          ]}
        ],
      },
      {
        menuName:'出入管控',icon: require('@/assets/img/menu/2/5.png'),path:'/attendance_rule',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"考勤管理",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            {name:'考勤规则',path:'/attendance_rule',jumpMode:0,showStatus:1},
            {name:'考勤记录',path:'/attendance_record',jumpMode:0,showStatus:1},
          ]},
          {name:"访客管理",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            {name:'访客记录',path:'/visitor_record',jumpMode:0,showStatus:1},
            {name:'访客人员',path:'/interviewed_person',jumpMode:0,showStatus:1},
          ]},
          {name:"学生请假管理",path:'/student_leave_management',jumpMode:0,showStatus:1,icon:'el-icon-postcard',list:[]},
          {name:"人脸设备管理",path:'/face_device_management',jumpMode:0,showStatus:1,icon:'el-icon-video-camera',list:[]},
        ],
      },
      // {
      //   menuName:'平安家校',icon:'/img/homeSchool.png',path:'/the_bus_route_manage',jumpMode:0,showStatus:1,menuCate:2,
      //   subMenuList:[
      //     {name:"校车管理",path:'',icon:'el-icon-truck',showStatus:1,list:[
      //       {name:'校车路线管理',path:'/the_bus_route_manage',jumpMode:0,showStatus:1},
      //       {name:'校车司机管理',path:'/school_bus_driver_manage',jumpMode:0,showStatus:1},
      //       {name:'跟车人员管理',path:'/car_following_manage',jumpMode:0,showStatus:1}
      //     ]}
      //   ],
      // },
      {
        menuName:'疫情防控',icon: require('@/assets/img/menu/2/8.png'),path:'/epidemic_work_guide',jumpMode:0,showStatus:1,menuCate:2,
        subMenuList:[
          {name:"校园防控工作指引",path:'/epidemic_work_guide',jumpMode:0,showStatus:1,icon:'el-icon-s-flag',list:[]},
          {name:"疫情防控知识",path:'/epidemic_prevention_knowledge',jumpMode:0,showStatus:1,icon:'el-icon-tickets',list:[]},
          {name:"健康排查表",path:'/health_checklist',jumpMode:0,showStatus:1,icon:'el-icon-document-remove',list:[]},
        ],
      },
      // {
      //   menuName:'校园风采',icon:'/img/xyfc.png',path:'/campus_dynamic',jumpMode:0,showStatus:1,menuCate:2,
      //   subMenuList:[
      //     {name:"校园动态",path:'/campus_dynamic',icon:'el-icon-school',jumpMode:0,showStatus:1,list:[]},
      //     {name:"教师风采",path:'/teacher_style',icon:'el-icon-user',jumpMode:0,showStatus:1,list:[]},
      //     {name:"班级风采",path:'/class_style',icon:'el-icon-house',jumpMode:0,showStatus:1,list:[]},
      //   ],
      // },
    ],

    indexMenu:[
      // 双重预防管理
      {
        menuName:'安全态势',icon:'/img/aqts.png',iconTwo:'/img/home_dsj.png',path:'/basics_info',jumpMode:1,showStatus:1,menuCate:1,
        subMenuList:[],
      },
      {
        menuName:'风险辨识管控',     icon: require('@/assets/img/menu/1/1.svg'),
        iconTwo:'/img/home_fxbs.png',path:'/leading_group',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"工作领导小组",path:'/leading_group',
          icon: require('@/assets/img/menu/1/2.svg'),
          act_icon: require('@/assets/img/menu/1/9.svg'),
          jumpMode:0,showStatus:1,list:[]},
          {name:"风险清单模型",path:'/risk_list_model',
          act_icon:require('@/assets/img/menu/1/8.svg'),

          icon: require('@/assets/img/menu/1/3.svg'),

          jumpMode:0,showStatus:1,list:[]},
          {name:"风险分级管控",path:'',
          icon: require('@/assets/img/menu/1/4.svg'),

          showStatus:1,list:[
            {name:"风险辨识",path:'/risk_identification',jumpMode:0,showStatus:1},
            {name:"风险评估",path:'/risk_assessment',jumpMode:0,showStatus:1},
            // {name:"分级管控清单",path:'/hierarchical_control_list',jumpMode:0,showStatus:1},
          ]},
          {name:"风险公告",
          icon: require('@/assets/img/menu/1/5.svg'),

          path:'',showStatus:1,list:[
            {name:"风险点公告栏",path:'/risk_notice',jumpMode:0,showStatus:1},
            {name:"岗位风险应知应会卡",path:'/risk_notification_card',jumpMode:0,showStatus:1},
            // {name:"展板",path:'/risk_notification_board',jumpMode:0,showStatus:1},
            // {name:"危险源告知卡（新）",path:'/risk_notice',jumpMode:0,showStatus:1},
            // {name:"事故应急处置卡（新）",path:'/risk_notice',jumpMode:0,showStatus:1},
            {name:"风险四色分布图",path:'/grade_chart_list',jumpMode:0,showStatus:1,sublevelList:[
              {name:"四色图列表",path:'/grade_chart_list'},
              {name:"四色图详情",path:'/grade_chart_details'}
            ]},
            {name:"风险四色比较图",path:'/risk_compare_chart',jumpMode:0,showStatus:1},
            {name:"自定义风险公告",path:'/notice_template',jumpMode:0,showStatus:1},
          ]},
          {name:"风险八台账",
          icon: require('@/assets/img/menu/1/6.svg'),
          path:'',jumpMode:0,showStatus:1,list:[
            {name:"制度建设资料",path:'/RiskInstitutionalBuilding',jumpMode:0,showStatus:1},
            {name:"安全风险单元",path:'/RiskUnitDivision',jumpMode:0,showStatus:1},
            {name:"危险源辨识及风险分析",path:'/RiskIdentificationAnalysis',jumpMode:0,showStatus:1},
            {name:"风险点清单",path:'/RiskInventoryList',jumpMode:0,showStatus:1},
            {name:"风险管控台账",path:'/risk_control_account',jumpMode:0,showStatus:1},
            {name:"风险管控责任清单",path:'/RiskControlList',jumpMode:0,showStatus:1},
            {name:"安全风险数据库",path:'/RiskDatabase',jumpMode:0,showStatus:1},
            {name:"隐患排查表",path:'/RiskHiddenDanger',jumpMode:0,showStatus:1},
          ]},
        ],
      },
      {
        menuName:'隐患排查治理',
        icon: require('@/assets/img/menu/1/yhzl.svg'),

        iconTwo:'/img/home_yhpc.png',path:'/hidden_danger_data',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"安全巡查",path:'',
          icon: require('@/assets/img/menu/1/aqxc.svg'),

          showStatus:1,list:[
            {name:"区域设置",path:'/patrol_area',jumpMode:0,showStatus:1},
            {name:"巡查任务",path:'/patrol_task',jumpMode:0,showStatus:1,sublevelList:[
              // {name:"巡查任务",path:'/patrol_task'},
              // {name:"巡查记录",path:'/patrol_record'}
            ]},
            {name:"巡查记录",path:'/patrol_record',jumpMode:0,showStatus:1},
            {name:"巡查值班",path:'/patrol_duty',jumpMode:0,showStatus:1},
            {name:"规避时间设置",path:'/AvoidTimeSetting',jumpMode:0,showStatus:1},
          ]},
          // {name:"定位巡查",path:'',icon:'el-icon-guide',showStatus:1,list:[
          //   {name:"定点列表",path:'/patrol_location',jumpMode:0,showStatus:1},
          //   {name:"巡查记录",path:'/patrol_location_record',jumpMode:0,showStatus:1}
          // ]},
          {name:"隐患管理",path:'',
          
          icon: require('@/assets/img/menu/1/yhgl.svg'),

          jumpMode:0,showStatus:1,list:[
            {name:"隐患数据",path:'/hidden_danger_data',jumpMode:0,showStatus:1},
            // {name:"隐患数据(新)",path:'/hidden_danger_data_detail',jumpMode:0,showStatus:1},
            {name:"隐患督办",path:'/hidden_danger_supervise',jumpMode:0,showStatus:1},
          ]},
          {name:"维修管理",path:'',jumpMode:0,showStatus:1,
          icon: require('@/assets/img/menu/1/wxgl.svg'),
          list:[
            {name:"维修数据",path:'/repair_data',jumpMode:0,showStatus:1}
          ]},
        ],
      },
      {
        menuName:'事故应急处理',icon: require('@/assets/img/menu/1/yjcl.svg'),iconTwo:'/img/home_yjcl.png',path:'/safety_accident',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"应急演练",path:'',showStatus:1,
          icon: require('@/assets/img/menu/1/yjyl.svg'),
          list:[
            {name:"应急演练设置",path:'/drill_evacuation_map',jumpMode:0,showStatus:1,sublevelList:[
              {name:"路线图",path:'/drill_evacuation_map'},
              {name:"救援器材",path:'/emergency_rescue_equipment'}
            ]},
            {name:"应急预案",path:'/emergency_plan',jumpMode:0,showStatus:1,sublevelList:[
              {name:"预案列表",path:'/emergency_plan'},
              {name:"公共预案库",path:'/public_plan_library'}
            ]},
            {name:"应急演练指挥中心",path:'/drill_center',jumpMode:1,showStatus:1},
          ]},
          {name:"安全事故",path:'/safety_accident',
          icon: require('@/assets/img/menu/1/aqsg.svg'),
          act_icon:require('@/assets/img/menu/1/7.svg'),
          jumpMode:0,showStatus:1,list:[]},
        ],
      },
    ],

    // 高校菜单(学院)
    indexMenuCollege:[
      // 双重预防管理
      {
        menuName:'安全态势',icon:'/img/aqts.png',iconTwo:'/img/home_dsj.png',path:'/basics_info',jumpMode:1,showStatus:1,menuCate:1,
        subMenuList:[],
      },
      {
        menuName:'风险辨识管控',icon: require('@/assets/img/menu/1/2.png'),iconTwo:'/img/home_fxbs.png',path:'/leading_group',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"工作领导小组",path:'/leading_group',icon:'el-icon-s-custom',jumpMode:0,showStatus:1,list:[]},
          {name:"风险清单模型",path:'/risk_list_model',icon:'el-icon-s-unfold',jumpMode:0,showStatus:1,list:[]},
          {name:"风险分级管控",path:'',icon:'el-icon-s-help',showStatus:1,list:[
            {name:"风险辨识",path:'/risk_identification',jumpMode:0,showStatus:1},
            {name:"风险评估",path:'/risk_assessment',jumpMode:0,showStatus:1},
            // {name:"分级管控清单",path:'/hierarchical_control_list',jumpMode:0,showStatus:1},
          ]},
          {name:"风险公告",path:'',icon:'el-icon-s-order',showStatus:1,list:[
            {name:"风险点公告栏",path:'/risk_notice',jumpMode:0,showStatus:1},
            {name:"岗位风险应知应会卡",path:'/risk_notification_card',jumpMode:0,showStatus:1},
            // {name:"展板",path:'/risk_notification_board',jumpMode:0,showStatus:1},
            // {name:"危险源告知卡（新）",path:'/risk_notice',jumpMode:0,showStatus:1},
            // {name:"事故应急处置卡（新）",path:'/risk_notice',jumpMode:0,showStatus:1},
            {name:"风险四色分布图",path:'/grade_chart_list',jumpMode:0,showStatus:1,sublevelList:[
              {name:"四色图列表",path:'/grade_chart_list'},
              {name:"四色图详情",path:'/grade_chart_details'}
            ]},
            {name:"风险四色比较图",path:'/risk_compare_chart',jumpMode:0,showStatus:1},
            {name:"自定义风险公告",path:'/notice_template',jumpMode:0,showStatus:1},
          ]},
          {name:"风险八台账",path:'',icon:'el-icon-s-grid',jumpMode:0,showStatus:1,list:[
            {name:"制度建设资料",path:'/RiskInstitutionalBuilding',jumpMode:0,showStatus:1},
            {name:"安全风险单元",path:'/RiskUnitDivision',jumpMode:0,showStatus:1},
            {name:"危险源辨识及风险分析",path:'/RiskIdentificationAnalysis',jumpMode:0,showStatus:1},
            {name:"风险点清单",path:'/RiskInventoryList',jumpMode:0,showStatus:1},
            {name:"风险管控台账",path:'/risk_control_account',jumpMode:0,showStatus:1},
            {name:"风险管控责任清单",path:'/RiskControlList',jumpMode:0,showStatus:1},
            {name:"安全风险数据库",path:'/RiskDatabase',jumpMode:0,showStatus:1},
            {name:"隐患排查表",path:'/RiskHiddenDanger',jumpMode:0,showStatus:1},
          ]},
        ],
      },
      {
        menuName:'隐患排查治理',icon: require('@/assets/img/menu/1/3.png'),iconTwo:'/img/home_yhpc.png',path:'/hidden_danger_data',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"安全巡查",path:'',icon:'el-icon-guide',showStatus:1,list:[
            {name:"区域设置",path:'/patrol_area',jumpMode:0,showStatus:1},
            {name:"巡查任务",path:'/patrol_task',jumpMode:0,showStatus:1,sublevelList:[
              // {name:"巡查任务",path:'/patrol_task'},
              // {name:"巡查记录",path:'/patrol_record'}
            ]},
            {name:"巡查记录",path:'/patrol_record',jumpMode:0,showStatus:1},
            {name:"巡查值班",path:'/patrol_duty',jumpMode:0,showStatus:1},
            {name:"规避时间设置",path:'/AvoidTimeSetting',jumpMode:0,showStatus:1},
          ]},
          // {name:"定位巡查",path:'',icon:'el-icon-guide',showStatus:1,list:[
          //   {name:"定点列表",path:'/patrol_location',jumpMode:0,showStatus:1},
          //   {name:"巡查记录",path:'/patrol_location_record',jumpMode:0,showStatus:1}
          // ]},
          {name:"隐患管理",path:'',icon:'el-icon-warning',jumpMode:0,showStatus:1,list:[
            {name:"隐患数据",path:'/hidden_danger_data',jumpMode:0,showStatus:1},
            // {name:"隐患数据(新)",path:'/hidden_danger_data_detail',jumpMode:0,showStatus:1},
            {name:"隐患督办",path:'/hidden_danger_supervise',jumpMode:0,showStatus:1},
          ]},
          {name:"维修管理",path:'',icon:'el-icon-s-tools',jumpMode:0,showStatus:1,list:[
            {name:"维修数据",path:'/repair_data',jumpMode:0,showStatus:1}
          ]},
        ],
      },
      {
        menuName:'事故应急处理',icon: require('@/assets/img/menu/1/4.png'),iconTwo:'/img/home_yjcl.png',path:'/safety_accident',jumpMode:0,showStatus:1,menuCate:1,
        subMenuList:[
          {name:"应急演练",path:'',icon:'el-icon-tickets',showStatus:1,list:[
            {name:"应急演练设置",path:'/drill_evacuation_map',jumpMode:0,showStatus:1,sublevelList:[
              {name:"路线图",path:'/drill_evacuation_map'},
              {name:"救援器材",path:'/emergency_rescue_equipment'}
            ]},
            {name:"应急预案",path:'/emergency_plan',jumpMode:0,showStatus:1,sublevelList:[
              {name:"预案列表",path:'/emergency_plan'},
              {name:"公共预案库",path:'/public_plan_library'}
            ]},
            {name:"应急演练指挥中心",path:'/drill_center',jumpMode:1,showStatus:1},
          ]},
          {name:"安全事故",path:'/safety_accident',jumpMode:0,showStatus:1,icon:'el-icon-warning',list:[]},
        ],
      },
    ],

    // 教育局菜单
    eduMenuList:[
      {
        name:'安全资料',icon:'',
        iconUrl1:require('@/assets/img/edu/menu/1.png') ,
        iconUrl:require('@/assets/img/edu/menu/1.png'),path:'/group_basic_info',level:1,list:[
          {
            name:'基础信息',icon:'el-icon-tickets',path:'/group_basic_info',level:2,
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/base.png',
            iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/base.png',
          },
          // {
          //   name:'权限管理',icon:'el-icon-guide',path:'/edu_authority',level:2,
          // },
          {
            name:'人员信息' ,
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_1.png',
            iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_1.png',icon:'el-icon-user',path:'/edu_user',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_2.png',

            name:'部门管理',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_2.png',icon:'el-icon-menu',path:'/edu_department',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_3.png',

            name:'职务管理',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_3.png',icon:'el-icon-news',path:'/edu_duties',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_4.png',

            name:'下属机构',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_4.png', icon:'el-icon-office-building',path:'/subsidiaries',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_5.png',

            name:'下属学校',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_5.png', icon:'el-icon-school',path:'/subordinate_school',level:2,
          },
          // {
          //   name:'下属街道',icon:'el-icon-school',path:'/bureau_edu',level:2,
          // },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/safe_6.png',

            name:'督办小组',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/safe_6.png', icon:'el-icon-s-check',path:'/supervision_group',level:2,
          },
        ],
      },
      {   
        iconUrl1:require('@/assets/img/edu/menu/2.png'),

        name:'安全管理',icon:'',iconUrl:require('@/assets/img/edu/menu/2.png'),
         path:'/task_issue_manage',level:1,list:[
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/manage_1.png',

            name:'隐患预警',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/manage_1.png', icon:'el-icon-pie-chart',path:'/eduHiddenDangerWarning',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/manage_2.png',

            name:'隐患数据',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/manage_2.png', icon:'el-icon-pie-chart',path:'/eduHiddenDangerData',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/manage_3.png',

            name:'隐患督办',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/manage_3.png', icon:'el-icon-pie-chart',path:'/eduHiddenDangerSupervise',level:2,
          },
          // {
            // name:'社会监督',icon:'el-icon-pie-chart',path:'/edu_data',level:2,
          // },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/manage_4.png',

            name:'校长专栏',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/manage_4.png',icon:'el-icon-pie-chart',path:'/eduPrincipalColumn',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/manage_5.png',

            name:'事故管理',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/manage_5.png', icon:'el-icon-pie-chart',path:'/SafetyAccident',level:2,
          },
          
          // {
            // name:'安全会议',icon:'el-icon-pie-chart',path:'/edu_data',level:2,
          // },
        ],
      },
      {
        iconUrl1:require('@/assets/img/edu/menu/3.png'),
        name:'护学管理',icon:'',iconUrl:require('@/assets/img/edu/menu/3.png'), path:'/nursing_post',level:1,list:[
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/protect_1.png',

            name:'人员管理',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/protect_1.png',icon:'el-icon-pie-chart',path:'/NursingPost',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/protect_2.png',

            name:'护学记录',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/protect_2.png',icon:'el-icon-pie-chart',path:'/NursingPostList',level:2,
          },
          {
            name:'护学监管',icon:'el-icon-pie-chart',path:'/ente_camera',level:2,
          },
          {
            name:'违停抓拍',icon:'el-icon-pie-chart',path:'/stop_catch_camera',level:2,
          },
        ],
      },
      
      // {
      //   name:'安全档案',icon:'el-icon-view',path:'/edu_data',level:1,list:[
      //     {
      //       name:'食堂档案统计',icon:'el-icon-film',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'安保档案统计',icon:'el-icon-s-marketing',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'消防档案统计',icon:'el-icon-s-marketing',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'器材档案统计',icon:'el-icon-s-marketing',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'校车档案统计',icon:'el-icon-s-marketing',path:'/edu_data',level:2,
      //     },
      //   ],
      // },
      {
        iconUrl1:require('@/assets/img/edu/menu/4.png'),

        name:'安全通知',icon:'',iconUrl:require('@/assets/img/edu/menu/4.png'), path:'/questionnaire_survey_manage',level:1,list:[
          // {
            // name:'待办事项',icon:'el-icon-box',path:'/edu_data',level:2,
          // },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/notice_1.png',

            name:'专项检查',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/notice_1.png',icon:'el-icon-pie-chart',path:'/special_inspect_task',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/notice_2.png',

            name:'检查项目',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/notice_2.png', icon:'el-icon-pie-chart',path:'/edu_inspect_project',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/notice_3.png',

            name:'消息通知',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/notice_3.png',icon:'el-icon-pie-chart',path:'/task_notices',level:2,
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/notice_4.png',

            name:'任务下发',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/notice_4.png',icon:'el-icon-pie-chart',path:'/task_issue_manage',level:2
          },
          // {
          //   name:'问卷调查',icon:'el-icon-edit-outline',path:'/questionnaire_survey_manage',level:2,
          // },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/notice_5.png',

            name:'问卷调查',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/notice_5.png',icon:'el-icon-edit-outline',path:'/questionnaire_survey',level:2,
          },
          // {
          //   name:'收件箱',icon:'el-icon-message',path:'/edu_data',level:2,
          // },
          // {
          //   name:'发件箱',icon:'el-icon-position',path:'/edu_data',level:2,
          // },
          // {
          //   name:'草稿箱',icon:'el-icon-chat-dot-square',path:'/edu_data',level:2,
          // },
          // {
          //   name:'整改通知',icon:'el-icon-postcard',path:'/edu_data',level:2,
          // },
        ],
      },
      {
        iconUrl1:require('@/assets/img/edu/menu/5.png'),
        name:'安全台账',
        icon:'',
        iconUrl:require('@/assets/img/edu/menu/5.png'), 
        path:'/hidden_export',
        level:1,
        list:[
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/tz_1.png',
            name:'巡查统计',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/tz_1.png',
            icon:'el-icon-edit-outline',
            path:'/patrol_export',
            level:2
          },
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/tz_2.png',
            name:'隐患统计',
            iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/tz_2.png',
            icon:'el-icon-edit-outline',
            path:'/hidden_export',
            level:2
          } 
        ],
      },
      {
        iconUrl1:require('@/assets/img/edu/menu/6.png'),
        name:'评分规则',
        icon:'',
        iconUrl:require('@/assets/img/edu/menu/6.png'), 
        path:'/inspection_rules',
        level:1,
        list:[
          {
            iconUrl1:'https://school.zzsasoft.com/uploads/icon/menIcon/active/rule.png',

            name:'评分规则',iconUrl:'https://school.zzsasoft.com/uploads/icon/menIcon/base/rule.png', icon:'el-icon-edit-outline',path:'/inspection_rules',level:2
          } 
        ],
      },
      // {
      //   iconUrl1:require('@/assets/img/edu/menu/13.png'),
      //   name:'安全物联',
      //   icon:'',
      //   iconUrl:require('@/assets/img/edu/menu/13.png'),
      //   path:'',
      //   level:1,
      //   list:[
      //     {
      //       name:'设备管理',icon:'el-icon-edit-outline',path:'/bureauofeducation/device_management',level:2
      //     },
      //     {
      //       name:'报警信息',icon:'el-icon-edit-outline',path:'/bureauofeducation/callthepolice_list',level:2
      //     }
      //   ],
      // },
      // {
      //   name:'安全教育',icon:'el-icon-s-claim',path:'/edu_data',level:1,list:[
      //     {
      //       name:'公共资源库',icon:'el-icon-document-copy',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'下属资源库',icon:'el-icon-document-copy',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'本地资源库',icon:'el-icon-document-copy',path:'/edu_data',level:2,
      //     },
      //     {
      //       name:'资源分类',icon:'el-icon-folder-opened',path:'/edu_data',level:2,
      //     },
      //   ],
      // },
      
      // {
      //   name:'大数据中心',icon:'',path:'/eduSecuritySituation_1',level:1,list:[],
      // },
    ],

    // 高校菜单
    universityMenuList:[
      {
        name:'安全资料',icon:'',path:'/group_basic_info',level:1,list:[
          {
            name:'基础信息',icon:'el-icon-tickets',path:'/group_basic_info',level:2,
          },
          // {
          //   name:'权限管理',icon:'el-icon-guide',path:'/edu_authority',level:2,
          // },
          {
            name:'人员信息',icon:'el-icon-user',path:'/edu_user',level:2,
          },
          {
            name:'部门管理',icon:'el-icon-menu',path:'/edu_department',level:2,
          },
          {
            name:'职务管理',icon:'el-icon-news',path:'/edu_duties',level:2,
          },
          {
            name:'下属机构',icon:'el-icon-school',path:'/un_subordinate_school',level:2,
          },
        ],
      },
      {
        name:'安全管理',icon:'',path:'/task_issue_manage',level:1,list:[
          // {
          //   name:'专项检查',icon:'el-icon-pie-chart',path:'/special_inspect_task',level:2,
          // },
          {
            name:'任务管理',icon:'el-icon-pie-chart',path:'/task_issue_manage',level:2
          },
          {
            name:'事故管理',icon:'el-icon-pie-chart',path:'/SafetyAccident',level:2,
          },
        ],
      },
      // {
        // name:'安全通知',icon:'el-icon-message-solid',path:'/questionnaire_survey_manage',level:1,list:[
          // {
          //   name:'问卷调查',icon:'el-icon-edit-outline',path:'/questionnaire_survey_manage',level:2,
          // }
        // ],
      // },
      {
        name:'安全台账',icon:'',path:'/inspection_rules',level:1,list:[
              {
                name:'评分规则',icon:'el-icon-edit-outline',path:'/inspection_rules',level:3
              } 
        ],
      },
      // {
      //   name:'大数据中心',icon:'el-icon-data-analysis',path:'/universityBigData',level:1,list:[],
      // },
      // {
      //   name:'大数据中心',icon:'',path:'/newUniversityBigData',level:1,list:[],
      // },
    ],

    // 后勤总公司
    logisticsCompany:[
      {
        name:'安全资料',icon:'el-icon-receiving',path:'/l_user_data',level:1,list:[
          {
            name:'人员信息',icon:'el-icon-user',path:'/l_user_data',level:2,
          },
          {
            name:'下属机构',icon:'el-icon-school',path:'/l_subordinate_body',level:2,
          },
          {
            name:'安全小组',icon:'el-icon-lock',path:'/l_security_group',level:2,
          },
        ]
      },
      {
        name:'隐患管理',icon:'el-icon-warning',path:'/l_colleges',level:1,list:[
          {
            name:'管理的院系',icon:'el-icon-user',path:'/l_colleges',level:2
          }
        ]
      }
    ]
  },
  mutations: {},
  actions: {},
  getters: {}
};
